import styled from "styled-components";
import {useEffect, useRef} from "react";

interface Props {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	data: any[] | null;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setSearchResult: (result: any | null) => void;
	searchableKeys?: string[];
}

const Container = styled.div`
	//background-color: '#3d3d3d';
	//border-color: '#3d3d3d';

	input {
		background-color: transparent;
		outline: none;
		border: none;
		font-size: 1.1rem;
		margin: .2rem .5rem;
		padding: .2rem;
		color: #f2f2f2;
		border-bottom: #f2f2f2 solid 1px;
	}

`;

export default function SearchInput({data, setSearchResult, searchableKeys}: Props) {

	const search = useRef<HTMLInputElement>(null);

	const applySearch = () => {
		if (!search.current) {
			setSearchResult(data);
			return;
		}
		if (!data) {
			setSearchResult(data);
			return;
		}
		const input = search.current.value.toLowerCase();
		if (!input) {
			setSearchResult(data);
			return;
		}
		setSearchResult(data.filter((v) => {
			for (const key of searchableKeys ? searchableKeys : Object.keys(v!)) {
				let value: unknown = v![key];
				if (typeof value !== "string" && typeof value !== "number") {
					continue;
				}
				value = String(value).toLowerCase();
				if ((value as string).includes(input))
					return true;
			}
			return false;
		}));

	}

	useEffect(() => {
		applySearch();
	}, [data]);

	return <Container>
		<input onInput={applySearch} ref={search} placeholder={'Search...'} />
	</Container>

}
